import api from '../../api/_vente'


const state = () => ({
    ventes: [],
})

// getters
const getters = {
    ventes: (state) => {
        return state.ventes
    },
}

// actions
const actions = {

    /**
     * Recuperer la liste des attributs possible pour un champ
     */
    getVentes({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getVentes(data).then(
                (response) => {
                    commit('SET_VENTES', response)
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },


    /**
     * Livraison d'une vente
     */
    livraisonVente({ dispatch }, {id, utilisateur}) {
        return new Promise((resolve, reject) => {
            api.livraison(id, utilisateur).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}

// mutations
const mutations = {
    
    SET_VENTES(state,ventes) {
        state.ventes = ventes
    },

}

export default {
  state,
  getters,
  actions,
  mutations
}
